import * as React from "react";
import Carousel from "nuka-carousel";
import YouTube, { Options } from "react-youtube";
import Modal from "@appComponents/Modal/Modal";
import { TState, TExtendMyAnimated } from "./IOverviewPage";
import { Link } from "react-router-dom";
import { MAIN_CURRENCY_LABEL } from "@bundles/consts";
import ExpansionPanel from "@appComponents/ExpansionPanel/ExpansionPanel";

import enterpriseSvg from "./images/enterprise.svg?url";
import shoopingCartSvg from "./images/shopping-cart.svg?url";
import moneySvg from "./images/money.svg?url";
import completeSvg from "./images/complete.svg?url";
import chooseSvg from "./images/choose.svg?url";
import signSvg from "./images/sign.svg?url";
import successSvg from "./images/success.svg?url";
import orderSvg from "./images/order.svg?url";
import marketSvg from "./images/market.svg?url";
import matchSvg from "./images/match.svg?url";
import transferSvg from "./images/transfer.svg?url";
import playSvg from "./images/play.svg?url";

import * as style from "./OverviewPageStyle.module.scss"
const groupImg = require("./images/group.png");
const swiftDoc = `${process.env.S3_PUBLIC_DOCUMENTS_ROOT_URL}pdfs/deposits-swift.pdf`;

const mainCurrency = MAIN_CURRENCY_LABEL.toUpperCase();

const questions = [
  {
    question: "What is USD*?",
    answer: [
      `All traditional currencies (Example USD, EUR, GBP, CNY, JPY and any other traditional currency) you send
      to Bnk To The Future are converted upon deposit into United States Dollars (USD) and held in a range of
      stablecoins that we call USD*. `,

      `These stablecoins are primarily held in TUSD (TrueUSD) and USDT (Tether), with some held in other
      stablecoins which may include but will not be limited to DAI, PAX, USDC, GUSD, BUSD amongst others.
      Therefore, your USD* balance on BF* is backed by a mix of US Dollar fiat funds, stablecoins backed by
      USD and some decentralised stablecoins. Hence any transaction on the BF Platform will occur in USD*
      unless you are investing, for example, in a Primary Offering through one of our Third Party Escrow
      Providers or you are paying in Credit or Debit Cards for an investment. `,

      `We have introduced USD* to make it easier for many of our investors to deposit and withdraw
      the type of USD/stablecoin they feel most comfortable with and is most convenient for them. `,
    ],
  },
  {
    question: "What is a USD stable coin?",
    answer: [
      `A USD stablecoin is a cryptocurrency that attempts to offer price stability with a pegged exchange rate
      (called a peg) to the US Dollar and is reported to be fully backed by USD dollars. Other stablecoins
      may use an algorithmic mechanism to try to maintain their peg to USD. Stablecoins attempt to offer
      the best of both worlds - instant processing-as easy as sending an email and remove volatility when
      investments are priced in dollars. `,

      `Please note that there is no guarantee the stablecoins will hold their peg to USD and therefore
      in an extreme event there may be currency and counterparty risks associated with each stablecoin.
      We diversify across a range of stablecoins in order to manage some of these risks, but investors
      should be aware of the currency and counterparty risks before depositing. `,
    ],
  },
  {
    question:
      "Which traditional currencies can I deposit and are there any fees to convert them?",
    answer: [
      `You are able to deposit any traditional currency supported by SWIFT. A full list can
      be found <a href=${swiftDoc} class=${style.link} target="_blank" rel="noopener noreferrer">.
      Once received the bank will convert them to USD at the exchange rate at the point
      of receipt and will charge bank fees which will only be known to us after the conversion has
      taken place. Investors will have to assume all currency risk and all third party fees will be
      deducted from their deposit. Unfortunately, banks only reveal the exchange rate and fees after
      processing the conversion so the extent of the fees will be unknown until after they are converted.`,
    ],
  },
  {
    question: "How does the BF Secondary Market trading work?",
    answer: [
      `Think of it as a bulletin board advertising buy and sell orders to our qualifying investors. Secondary
       Market trading is similar to an Over-The-Counter Market. Sell Orders are filled manually by buyers. Also
       buyers can post Buy Orders which are filled by sellers.`,

      `Note that due to limited liquidity on private equity offers,
       there's no matching engine and order fulfilment might take longer than on a full exchange.`,
    ],
  },
  {
    question: `What is a minimum order amount on Secondary Market?`,
    answer: [`The minimum order amount is 1000 ${mainCurrency}.`],
  },
  {
    question: `What is a minimum trade amount on Secondary Market?`,
    answer: [`The minimum trade amount is 1000 ${mainCurrency}.`],
  },
  {
    question: `How can I start investing in Secondary Private Equity?`,
    answer: [
      `First, make sure you are eligible to invest by completing our verification and certification processes.`,

      `Then you can deposit ${mainCurrency} on BnkToTheFuture.com. Once the funds are transferred and available on
             your account, you can then browse available orders and make an instant bid, or create Buy Order and
             define your desired price.`,
    ],
  },
  {
    question: `How can I sell my shares?`,
    answer: [
      `First, check if your investor status is valid and you are currently eligible to trade in your country.`,

      `Then, choose an SPV which you want to liquidate. You can sell your shares in two ways - either by creating
             a Sell Order and defining your expected price or by filling one of the available Buy Orders.`,
    ],
  },
  {
    question: `Can I buy shares with BTC?`,
    answer: [
      `At the moment we only accept ${mainCurrency} on the Secondary Market.
             We plan to offer more options in the future.`,
    ],
  },
  {
    question: `How does BFT discount work?`,
    answer: [
      `When creating an order or making a trade, you can receive a 50% fee discount on trading when you pay the
             fee in BnkToTheFuture Tokens (BFT). Before making a trade, make sure you have enough BFT deposited on
             the platform.`,

      `Note that when you create a Sell Order or Buy Order we freeze BFT at the current market price, to
             cover the fee amount.`,
    ],
  },
  {
    question: `Can I trade as a US resident?`,
    answer: [
      `At the moment due to regulatory restrictions, we don't support buyers from the United States. Our legal
             team is working towards obtaining the appropriate registrations to allow for this in the future.`,

      `As a US resident, If you hold tradable assets bought on BnkTotTheFuture.com, you are eligible to sell
             them one year after your initial pitch investment.`,
    ],
  },
  {
    question: `How can I sell an asset that is not currently on the market?`,
    answer: [
      `If the investment was made through BnkToTheFuture.com, we'll aim to get the asset tradable as soon as
             we believe the liquidity will make it feasible. If you have acquired the equity from an external
             source, please contact Support who will be able to assess your eligibility.`,
    ],
  },
  {
    question: `How can I find information about a company that's currently traded?`,
    answer: [
      `While BnkToTheFuture.com does not provide official guides or investment advice, don't forget to visit the
             Company Page, where the information and content have been curated by our community.`,
    ],
  },
  {
    question: `Why is my money blocked/unblocked when initiating an order?`,
    answer: [
      `If you initiate an unfilled order then you are unable to use those funds for anything else on the platform.
             To make this clear we block the funds until the order is cancelled or filled to prevent you from spending
             the funds more than once. If you cancel the order the funds will automatically be unblocked for you to
             invest, place another order or withdraw subject to withdrawal fees.`,
    ],
  },
  {
    question: `Will the trade fee change if BFT price fluctuates?`,
    answer: [
      `When you create a Sell Order or Buy Order we freeze BFT at the current market price, to cover
             the fee amount.`,
    ],
  },
  {
    question: `Is there a withdrawal fee when withdrawing funds?`,
    answer: [
      `We charge a 1% withdrawal fee when withdrawing ${mainCurrency} through BnkToTheFuture.com.`,
    ],
  },
  {
    question: `What are the fees?`,
    answer: [
      `We charge 2.5% if your buy or sell order is filled and to complete all the share transfer agreements and
             escrow of funds. We do not charge anything to place an order. If the trade is not executed you do not
             pay any fee.`,
    ],
  },
];

const playerSettings: Options = {
  height: "100%",
  width: "100%",
  playerVars: {
    rel: 0,
    showinfo: 0,
  },
};

let timeout = 0;
let animateElements: NodeListOf<HTMLElement> | any = [];

export class OverviewPage extends React.Component<{}, TState> {
  private playerRef: React.RefObject<YouTube | any> = React.createRef();
  constructor(props: {}) {
    super(props);

    this.state = {
      ...this.getBenefitsOptions(),
      ...this.getBuyingProcessOptions(),
      ...this.getSellingProcessOptions(),
      showBuyingSection: true,
      resizeHelper: true,
      videoLength: "",
      showPlayer: false,
    };
  }

  componentDidMount() {
    animateElements = document.querySelectorAll("[data-animation]");
    for (let i = 0; i < animateElements.length; i += 1) {
      animateElements[i]._myanimated = false;
    }

    setTimeout(() => {
      this.handleAnimation();
    }, 0);

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleAnimation);

    // hack for Carousel bug
    this.setCarouselDots();
    window.dispatchEvent(new Event("resize"));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleAnimation);
  }

  handleResize = () => {
    clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      if (this.state.resizeHelper) {
        this.setState({
          ...this.getBenefitsOptions(),
          ...this.getBuyingProcessOptions(),
          ...this.getSellingProcessOptions(),
          resizeHelper: false,
        });

        // hack for Carousel bug
        window.dispatchEvent(new Event("resize"));

        // handle new elements for animation
        animateElements = document.querySelectorAll("[data-animation]");
        this.handleAnimation();
      } else {
        this.setState({ resizeHelper: true });
      }
    }, 200);
  };

  handleAnimation = () => {
    for (let i = 0; i < animateElements.length; i += 1) {
      if (this.isElementVisible(animateElements[i])) {
        setTimeout(() => {
          animateElements[i].classList.add(
            `${style[animateElements[i].getAttribute("data-animation")]}`
          );
          animateElements[i]._myanimated = true;
        }, animateElements[i].getAttribute("data-delay") || 0);
      }
    }
  };

  getBenefitsOptions = () => {
    if (window.innerWidth < 800) {
      return { benefits: { slidesToShow: 1, touching: true } };
    }

    return { benefits: { slidesToShow: 3, touching: false } };
  };

  getBuyingProcessOptions = () => {
    if (window.innerWidth < 640) {
      return { buying: { slidesToShow: 1, touching: true } };
    }

    if (window.innerWidth < 1000) {
      return { buying: { slidesToShow: 2, touching: true } };
    }

    return { buying: { slidesToShow: 4, touching: false } };
  };

  getSellingProcessOptions = () => {
    if (window.innerWidth < 640) {
      return { selling: { slidesToShow: 1, touching: true } };
    }

    if (window.innerWidth < 1000) {
      return { selling: { slidesToShow: 2, touching: true } };
    }

    return { selling: { slidesToShow: 4, touching: false } };
  };

  setCarouselDots() {
    const dots: HTMLCollectionOf<Element> = document.getElementsByClassName(
      "slider-control-bottomcenter"
    );
    Array.from(dots).forEach((dot: HTMLElement) => {
      dot.style.position = "relative";
      dot.style.marginTop = "25px";
      dot.style.textAlign = "center";
    });
  }

  setProcessSection = (e: React.MouseEvent<HTMLHeadingElement>) => {
    this.setState(
      { showBuyingSection: !!Number(e.currentTarget.dataset.section) },
      () => {
        // handle new elements for animation
        animateElements = document.querySelectorAll("[data-animation]");
        this.handleAnimation();

        // hack for Carousel bug
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 0);
      }
    );
  };

  isElementVisible = (elem: TExtendMyAnimated<HTMLElement>) => {
    if (!elem._myanimated) {
      const rect = elem.getBoundingClientRect();

      return !(rect.bottom < 140 || rect.top - window.innerHeight >= -140);
    }

    return false;
  };

  playerReady = (event: any) => {
    this.setState({ videoLength: `0:${event.target.getDuration()} sec.` });
  };

  playerEnd = (event: any) => {
    event.target.clearVideo();
    this.setState({ showPlayer: false });
  };

  showVideo = () => {
    if (!this.state.showPlayer) {
      this.setState({ showPlayer: true });
    }
  };

  hideModal = () => {
    if (this.playerRef.current) {
      this.playerRef.current.resetPlayer();
    }
    this.setState({ showPlayer: false });
  };

  render() {
    return (
      <div className={style.overview}>
        <div className={style.overviewTop}>
          <header className={style.header}>
            <h1 className={style.scrollAnimation} data-animation="fade-in-down">
              Buy and sell private shares from other investors in a compliant
              environment
            </h1>
            <p>
              The Bnktothefuture Secondary Market operates as a platform board
              that enables you to sell or buy shares held under the
              Bnktothefuture SPV structure.
            </p>
            <Link
              to={"/market/spvs"}
              className={style.button}
              data-cy="start-trading"
            >
              Start trading now
            </Link>
            <p className={style.terms}>
              Please see the
              <a href={`${process.env.WORDPRESS_DOMAIN}/terms-conditions`}>
                Secondary Market Terms & Conditions.
              </a>
            </p>
          </header>
        </div>
        <div className={style.laptop}>
          <img
            src={groupImg}
            alt="Secondary Market"
          />
          <div className={style.yt} onClick={this.showVideo}>
            <img className={style.playIcon} src={playSvg} />
            <div className={style.ytContent}>
              <span className={style.title}>Watch Video</span>
              <span className={style.videoLength}>
                {this.state.videoLength}
              </span>
            </div>
          </div>
        </div>
        <div
          className={[
            this.state.showPlayer
              ? style.playerModalVisible
              : style.playerModalHidden,
          ].join(" ")}
        >
          <Modal
            cancel={this.hideModal}
            show={this.state.showPlayer}
            className={{
              container: style.playerContainer,
              dialog: style.playerDialog,
              footer: style.playerFooter,
              close: style.playerClose,
              content: style.playerContent,
              header: style.playerHeader,
            }}
          >
            <YouTube
              videoId="kad2Y7-Fbh4"              
              containerClassName={style.playerYtContainer}
              opts={playerSettings}
              onReady={this.playerReady}
              onEnd={this.playerEnd}
              ref={this.playerRef}
            />
          </Modal>
        </div>
        <section className={[style.questions, style.container].join(" ")}>
          <h2>Frequently asked questions (FAQ)</h2>
          <ExpansionPanel questions={questions} />
        </section>
        <section className={style.process}>
          <div className={style.headlines}>
            <h2
              className={`${style.headlineActive} ${style.headlineActiveNoPointer}`}
              data-section={1}
            >
              Trading Process
            </h2>
          </div>
          {this.renderProcessSection()}
        </section>
        <section className={[style.benefits, style.container].join(" ")}>
          <h2>Benefits</h2>
          <Carousel
            withoutControls={window.innerWidth > 800}
            renderCenterRightControls={() => <React.Fragment />}
            renderCenterLeftControls={() => <React.Fragment />}
            renderBottomCenterControls={this.renderDots}
            slidesToShow={this.state.benefits.slidesToShow}
            swiping={this.state.benefits.touching}
            dragging={this.state.benefits.touching}
            heightMode="max"
            onResize={this.setCarouselDots}
          >
            <div className={style.benefitsCol}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                src={shoopingCartSvg}
                alt="Buyers"
              />
              <h4>Buyers</h4>
              <ul>
                <li>Invest of equity even after the funding round is closed</li>
                <li>
                  Increase your position in the businesses you already own
                </li>
                <li>
                  Opportunity to beat the valuations of future funding rounds
                </li>
              </ul>
            </div>
            <div className={style.benefitsCol}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                src={moneySvg}
                alt="Sellers"
              />
              <h4>Sellers</h4>
              <ul>
                <li>
                  <span>Investment liquidity regardless of IPO timing</span>
                </li>
                <li>
                  <span>Adjust your portfolio according to market trends</span>
                </li>
                <li>Receive profits directly into your BF Funds</li>
              </ul>
            </div>
            <div className={style.benefitsCol}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                src={enterpriseSvg}
                alt="Companies"
              />
              <h4>Companies</h4>
              <ul>
                <li>
                  Provide an exit to investors even if you’re not ready yourself
                </li>
                <li>
                  Liquid markets will attract more investors in future rounds
                </li>
                <li>All admin handled by out SPV structure</li>
              </ul>
            </div>
          </Carousel>
        </section>

        <section className={style.bar}>
          <h2>Looking for liquidity on your shares?</h2>
          <Link
            className={[style.scrollAnimation, style.button].join(" ")}
            data-animation="fade-in-up"
            to={"/market/spvs"}
          >
            Learn more
          </Link>
        </section>
      </div>
    );
  }

  renderDots = (props: {
    slideCount: number;
    currentSlide: number;
    slidesToShow: number;
    goToSlide: Function;
  }) => {
    const dots = [];
    for (let i = 0; i < props.slideCount - props.slidesToShow + 1; i += 1) {
      dots.push(
        <div
          onClick={() => {
            props.goToSlide(i);
          }}
          key={i}
          className={props.currentSlide === i ? style.active : undefined}
        />
      );
    }

    return <div className={style.dots}>{dots.map(item => {item})}</div>;
  };

  renderProcessSection = () => {
    const toRender = [];

    toRender.push(
      <React.Fragment key={1}>
        {window.innerWidth < 1000 && (
          <div className={style.headlines}>
            <h2
              className={`${style.headlineActive} ${style.headlineActiveNoPointer}`}
            >
              Trading Process
            </h2>
          </div>
        )}
        <div className={style.container}>
          <Carousel
            withoutControls={window.innerWidth > 1000}
            renderCenterRightControls={() => <React.Fragment />}
            renderCenterLeftControls={() => <React.Fragment />}
            renderBottomCenterControls={this.renderDots}
            slidesToShow={this.state.buying.slidesToShow}
            swiping={this.state.buying.touching}
            dragging={this.state.buying.touching}
            heightMode="max"
            onResize={this.setCarouselDots}
          >
            <div className={[style.contentHolder].join(" ")}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                src={completeSvg}
              />
              <h4>
                Complete
                <br />
                your account
              </h4>
              <p>Verify and Certify your investor account on Bnktothefuture</p>
            </div>
            <div className={[style.contentHolder].join(" ")}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                data-delay={200}
                src={chooseSvg}
              />
              <h4>
                Choose
                <br />
                the company
              </h4>
              <p>
                You can either select an existing offer or place a new order at
                a desired price
              </p>
            </div>
            <div className={[style.contentHolder].join(" ")}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                data-delay={400}
                src={signSvg}
              />
              <h4>
                Presign the
                <br />
                agreement
              </h4>
              <p>
                Confirm the transaction by presigning a contract which will
                become legally binding upon completion
              </p>
            </div>
            <div className={[style.contentHolder].join(" ")}>
              <img
                className={style.scrollAnimation}
                data-animation="fade-in-up"
                data-delay={600}
                src={successSvg}
              />
              <h4>
                Shares are
                <br />
                transferred
              </h4>
              <p>
                Once the order is matched and payment is out of the way, the
                contract will get countersigned and the shares balances will be
                updated in your portfolio
              </p>
            </div>
          </Carousel>
        </div>
      </React.Fragment>
    );
    return toRender;
  };

  renderProcessSections = () => {
    const toRender = [];

    (this.state.showBuyingSection || window.innerWidth < 1000) &&
      toRender.push(
        <React.Fragment key={1}>
          {window.innerWidth < 1000 && (
            <div className={style.headlines}>
              <h2 className={style.headlineActive}>Buying Process</h2>
            </div>
          )}
          <div className={style.container}>
            <Carousel
              withoutControls={window.innerWidth > 1000}
              renderCenterRightControls={() => <React.Fragment />}
              renderCenterLeftControls={() => <React.Fragment />}
              renderBottomCenterControls={this.renderDots}
              slidesToShow={this.state.buying.slidesToShow}
              swiping={this.state.buying.touching}
              dragging={this.state.buying.touching}
              heightMode="max"
              onResize={this.setCarouselDots}
            >
              <div className={[style.contentHolder].join(" ")}>
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  src={completeSvg}
                />
                <h4>
                  Complete
                  <br />
                  your account
                </h4>
                <p>
                  Verify and Certify your investor account on Bnktothefuture
                </p>
              </div>
              <div className={[style.contentHolder].join(" ")}>
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={200}
                  src={chooseSvg}
                />
                <h4>
                  Choose
                  <br />
                  shares
                </h4>
                <p>Shares are available on first come, first served basis</p>
              </div>
              <div className={[style.contentHolder].join(" ")}>
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={400}
                  src={signSvg}
                />
                <h4>
                  Presign the
                  <br />
                  agreement
                </h4>
                <p>
                  Confirm the transaction by presigning a contract which will
                  become legally binding upon payment
                </p>
              </div>
              <div className={[style.contentHolder].join(" ")}>
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={600}
                  src={completeSvg}
                />
                <h4>
                  Make
                  <br />a payment
                </h4>
                <p>
                  Instant payment from your BF Funds or pay via private wallet
                </p>
              </div>
              <div className={[style.contentHolder].join(" ")}>
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={800}
                  src={successSvg}
                />
                <h4>
                  Shares are
                  <br />
                  transferred
                </h4>
                <p>
                  Once payment is out of the way, the contract will get
                  countersigned and the shares will appear in your portfolio
                </p>
              </div>
            </Carousel>
          </div>
        </React.Fragment>
      );

    (!this.state.showBuyingSection || window.innerWidth < 1000) &&
      toRender.push(
        <React.Fragment key={2}>
          {window.innerWidth < 1000 && (
            <div className={style.headlines}>
              <h2 className={style.headlineActive}>Selling Process</h2>
            </div>
          )}
          <div className={style.container}>
            <Carousel
              withoutControls={window.innerWidth > 1000}
              renderCenterRightControls={() => <React.Fragment />}
              renderCenterLeftControls={() => <React.Fragment />}
              renderBottomCenterControls={this.renderDots}
              slidesToShow={this.state.selling.slidesToShow}
              swiping={this.state.selling.touching}
              dragging={this.state.selling.touching}
              heightMode="max"
              onResize={this.setCarouselDots}
            >
              <div
                className={[style.contentHolder, style.sellContentHolder].join(
                  " "
                )}
              >
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  src={orderSvg}
                />
                <h4>
                  Create
                  <br />
                  an order
                </h4>
                <p>
                  Select the company, the number of shares you’d like to list
                  and the asking price
                </p>
              </div>
              <div
                className={[style.contentHolder, style.sellContentHolder].join(
                  " "
                )}
              >
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={200}
                  src={marketSvg}
                />
                <h4>
                  Shares
                  <br />
                  go to market
                </h4>
                <p>
                  Your offer will be available on the company market for other
                  investors to buy
                </p>
              </div>
              <div
                className={[style.contentHolder, style.sellContentHolder].join(
                  " "
                )}
              >
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={400}
                  src={matchSvg}
                />
                <h4>
                  Match is
                  <br />
                  found
                </h4>
                <p>Someone buys your offer either in full, or its part</p>
              </div>
              <div
                className={[style.contentHolder, style.sellContentHolder].join(
                  " "
                )}
              >
                <img
                  className={style.scrollAnimation}
                  data-animation="fade-in-up"
                  data-delay={600}
                  src={transferSvg}
                />
                <h4>
                  Shares are
                  <br />
                  transferred
                </h4>
                <p>
                  Upon receipt of payment, the relevant shares will leave your
                  account and your BF Funds balance credited
                </p>
              </div>
            </Carousel>
          </div>
        </React.Fragment>
      );

    return toRender;
  };
}

export default OverviewPage;
